/**
 * Global Loading Service
 *
 * Signal-basierter Service fuer globalen Loading-State.
 * Wird in app.component verwendet um ein Fullscreen-Overlay anzuzeigen
 * das das komplette UI blockiert bis die Initialisierung abgeschlossen ist.
 */

import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalLoadingService {
  private _isLoading = signal(false);
  private _statusText = signal('');

  /** Ist die App im Loading-State? */
  readonly isLoading = this._isLoading.asReadonly();

  /** Aktueller Status-Text */
  readonly statusText = this._statusText.asReadonly();

  /** Startet den globalen Loading-State */
  show(statusText = ''): void {
    this._statusText.set(statusText);
    this._isLoading.set(true);
  }

  /** Aktualisiert nur den Status-Text */
  updateStatus(statusText: string): void {
    this._statusText.set(statusText);
  }

  /** Beendet den globalen Loading-State */
  hide(): void {
    this._isLoading.set(false);
    this._statusText.set('');
  }
}
